import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { t } from "@/lib/i18n";

export function Stars({ rating, size = "w-3.5 h-3.5", testId }) {
  if (!rating?.count) return <span className="text-[11px] font-mono text-slate-400" data-testid={testId}>{t("NEW · NO RATINGS")}</span>;
  return (
    <span className="inline-flex items-center gap-1" data-testid={testId}>
      <Star className={`${size} fill-amber-400 text-amber-400`} />
      <span className="font-mono text-xs font-bold">{rating.avg.toFixed(1)}</span>
      <span className="font-mono text-[11px] text-slate-400">({rating.count})</span>
    </span>
  );
}

export function StarRow({ value, onChange, size = "w-7 h-7" }) {
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" disabled={!onChange} onClick={() => onChange?.(n)} data-testid={`star-${n}`} className="transition-transform hover:scale-110 disabled:hover:scale-100">
          <Star className={`${size} ${n <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
        </button>
      ))}
    </div>
  );
}

export function RateForm({ bidId, name, onDone }) {
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/connections/${bidId}/rate`, { stars, comment });
      toast.success(t("Thanks — rating submitted"));
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="space-y-3" data-testid="rate-form">
      <p className="text-sm">{t("How was working with")} <b>{name}</b>?</p>
      <StarRow value={stars} onChange={setStars} />
      <textarea rows={2} value={comment} onChange={(e) => setComment(e.target.value)} placeholder={t("Optional comment (punctuality, communication…)")} className="hf-input" data-testid="rate-comment-input" />
      <button disabled={!stars || busy} onClick={submit} className="hf-btn-primary w-full" data-testid="btn-submit-rating">{t("Submit rating")}</button>
    </div>
  );
}
